import script from "./MediaGalleryList.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaGalleryList.vue?vue&type=script&setup=true&lang=js"

import "./MediaGalleryList.vue?vue&type=style&index=0&id=41388228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41388228"]])

export default __exports__